<template>
    <div id="navigation-button" @click="navigate">
        <div class="navigation-button">
            <svg
                v-if="!action"
                width="100%"
                height="100%"
                preserveAspectRatio="none"
                viewBox="0 0 201 94"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="navigation-button_back"
            >
                <mask id="path-1-inside-1" fill="white">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M32.4228 89.8686C31.5994 89.259 30.8423 88.5364 30.176 87.7025L3.48286 54.2922C0.117692 50.0802 0.117694 44.2293 3.48286 40.0173L30.176 6.60709C30.6434 6.02207 31.1555 5.49186 31.7038 5.01701C33.9033 2.28403 37.2761 0.535156 41.0573 0.535156H188.865C195.492 0.535156 200.865 5.90774 200.865 12.5352V81.5352C200.865 88.1626 195.492 93.5352 188.865 93.5352H41.0573C37.667 93.5352 34.6052 92.1292 32.4228 89.8686Z"
                    />
                </mask>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M32.4228 89.8686C31.5994 89.259 30.8423 88.5364 30.176 87.7025L3.48286 54.2922C0.117692 50.0802 0.117694 44.2293 3.48286 40.0173L30.176 6.60709C30.6434 6.02207 31.1555 5.49186 31.7038 5.01701C33.9033 2.28403 37.2761 0.535156 41.0573 0.535156H188.865C195.492 0.535156 200.865 5.90774 200.865 12.5352V81.5352C200.865 88.1626 195.492 93.5352 188.865 93.5352H41.0573C37.667 93.5352 34.6052 92.1292 32.4228 89.8686Z"
                    fill="url(#paint0_linear-white)"
                />
                <path
                    d="M32.4228 89.8686L33.1423 89.1741L33.0846 89.1143L33.0178 89.0649L32.4228 89.8686ZM30.176 87.7025L29.3947 88.3267L29.3947 88.3267L30.176 87.7025ZM3.48286 54.2922L2.70159 54.9164H2.70159L3.48286 54.2922ZM3.48286 40.0173L4.26413 40.6415L3.48286 40.0173ZM30.176 6.60709L30.9572 7.23129L30.176 6.60709ZM31.7038 5.01701L32.3585 5.77296L32.4265 5.71407L32.4829 5.64399L31.7038 5.01701ZM33.0178 89.0649C32.2627 88.5059 31.5685 87.8434 30.9572 87.0783L29.3947 88.3267C30.116 89.2295 30.936 90.0121 31.8279 90.6723L33.0178 89.0649ZM30.9572 87.0783L4.26413 53.668L2.70159 54.9164L29.3947 88.3267L30.9572 87.0783ZM4.26413 53.668C1.1906 49.8211 1.1906 44.4885 4.26413 40.6415L2.70159 39.3931C-0.955216 43.9702 -0.955218 50.3394 2.70159 54.9164L4.26413 53.668ZM4.26413 40.6415L30.9572 7.23129L29.3947 5.9829L2.70159 39.3931L4.26413 40.6415ZM30.9572 7.23129C31.3861 6.69447 31.8558 6.20828 32.3585 5.77296L31.0492 4.26106C30.4552 4.77544 29.9006 5.34967 29.3947 5.9829L30.9572 7.23129ZM32.4829 5.64399C34.5007 3.13672 37.5916 1.53516 41.0573 1.53516V-0.464844C36.9606 -0.464844 33.306 1.43133 30.9248 4.39004L32.4829 5.64399ZM41.0573 1.53516H188.865V-0.464844H41.0573V1.53516ZM188.865 1.53516C194.94 1.53516 199.865 6.46002 199.865 12.5352H201.865C201.865 5.35545 196.045 -0.464844 188.865 -0.464844V1.53516ZM199.865 12.5352V81.5352H201.865V12.5352H199.865ZM199.865 81.5352C199.865 87.6103 194.94 92.5352 188.865 92.5352V94.5352C196.045 94.5352 201.865 88.7149 201.865 81.5352H199.865ZM188.865 92.5352H41.0573V94.5352H188.865V92.5352ZM41.0573 92.5352C37.9494 92.5352 35.144 91.2476 33.1423 89.1741L31.7034 90.5631C34.0663 93.0109 37.3847 94.5352 41.0573 94.5352V92.5352Z"
                    fill="#9A9A9A"
                    mask="url(#path-1-inside-1)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear-white"
                        x1="176.791"
                        y1="0"
                        x2="176.791"
                        y2="93"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="white" />
                        <stop offset="1" stop-color="#E0E8EB" />
                    </linearGradient>
                </defs>
            </svg>
            <svg
                v-else
                width="100%"
                height="100%"
                preserveAspectRatio="none"
                viewBox="0 0 297 93"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="navigation-button_next"
            >
                <mask id="path-1-inside-1-2" fill="white">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M266.577 89.3927C267.512 88.7209 268.367 87.9002 269.108 86.9328L294.386 53.9142C297.682 49.6094 297.682 43.6296 294.386 39.3248L269.108 6.30624C268.558 5.5882 267.945 4.95097 267.283 4.39549C265.083 1.71208 261.741 0 258 0H12C5.37262 0 3.05176e-05 5.37258 3.05176e-05 12V81C3.05176e-05 87.6274 5.37262 93 12 93H258C261.361 93 264.399 91.6186 266.577 89.3927Z"
                    />
                </mask>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M266.577 89.3927C267.512 88.7209 268.367 87.9002 269.108 86.9328L294.386 53.9142C297.682 49.6094 297.682 43.6296 294.386 39.3248L269.108 6.30624C268.558 5.5882 267.945 4.95097 267.283 4.39549C265.083 1.71208 261.741 0 258 0H12C5.37262 0 3.05176e-05 5.37258 3.05176e-05 12V81C3.05176e-05 87.6274 5.37262 93 12 93H258C261.361 93 264.399 91.6186 266.577 89.3927Z"
                    fill="url(#paint0_linear-1)"
                />
                <path
                    d="M266.577 89.3927L265.862 88.6932L265.923 88.6312L265.993 88.5806L266.577 89.3927ZM269.108 86.9328L269.902 87.5407H269.902L269.108 86.9328ZM294.386 53.9142L295.18 54.5221H295.18L294.386 53.9142ZM294.386 39.3248L293.592 39.9327L294.386 39.3248ZM269.108 6.30624L269.902 5.69835L269.108 6.30624ZM267.283 4.39549L266.64 5.16136L266.569 5.10155L266.51 5.02962L267.283 4.39549ZM265.993 88.5806C266.849 87.9657 267.633 87.2136 268.314 86.3249L269.902 87.5407C269.101 88.5868 268.174 89.4761 267.161 90.2047L265.993 88.5806ZM268.314 86.3249L293.592 53.3063L295.18 54.5221L269.902 87.5407L268.314 86.3249ZM293.592 53.3063C296.613 49.3603 296.613 43.8788 293.592 39.9327L295.18 38.717C298.75 43.3804 298.75 49.8586 295.18 54.5221L293.592 53.3063ZM293.592 39.9327L268.314 6.91412L269.902 5.69835L295.18 38.717L293.592 39.9327ZM268.314 6.91412C267.808 6.25438 267.246 5.67007 266.64 5.16136L267.926 3.62962C268.644 4.23187 269.307 4.92203 269.902 5.69835L268.314 6.91412ZM266.51 5.02962C264.491 2.56788 261.429 1 258 1V-1C262.053 -1 265.674 0.856281 268.057 3.76135L266.51 5.02962ZM258 1H12V-1H258V1ZM12 1C5.9249 1 1.00003 5.92487 1.00003 12H-0.999969C-0.999969 4.8203 4.82034 -1 12 -1V1ZM1.00003 12V81H-0.999969V12H1.00003ZM1.00003 81C1.00003 87.0751 5.9249 92 12 92V94C4.82034 94 -0.999969 88.1797 -0.999969 81H1.00003ZM12 92H258V94H12V92ZM258 92C261.081 92 263.864 90.7349 265.862 88.6932L267.292 90.0921C264.933 92.5023 261.64 94 258 94V92Z"
                    fill="#9A9A9A"
                    mask="url(#path-1-inside-1-2)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear-1"
                        x1="148.429"
                        y1="0"
                        x2="148.429"
                        y2="93"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="white" />
                        <stop offset="1" stop-color="#E0E8EB" />
                    </linearGradient>
                </defs>
            </svg>

            <div class="navigation-button-text" :style="{ color: textColor }">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'navigation-button',
    props: ['action', 'textColor'],
    methods: {
        navigate() {
            this.$emit('navigate');
        }
    }
};
</script>

<style lang="scss" scoped>
#navigation-button {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.navigation-button {
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    filter: brightness(100%);
    transition: filter .2s ease;
    &:active {
        filter: brightness(90%);
    }
    & svg {
        position: absolute;
    }
    &-text {
        position: relative;
        margin: auto;
        font-weight: bold;
        user-select: none;
        font-size: 3rem;
    }
    &_next + &-text {
        transform: translate(-25%, 0);
    }
    &_back + &-text {
        transform: translate(25%, 0);
    }
}
</style>



// WEBPACK FOOTER //
// front/src/skins/xkiosk/components/button/africa/navigation-button.vue